import { FC } from 'react';
import FieldCard from 'components/FieldCard';
import { HandleEditItem, HandleRemoveItem } from 'components/QuickForm/QuickForm.types';
import Box from 'yoda-ui/components/Box';
import Icon, { Icons } from 'yoda-ui/components/Icons/Icon/Icon';
import { YodaColors, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type CardRowProps = {
  item: { id: string; property1: string; property2: string; property3?: string };
  handleRemoveItem: HandleRemoveItem;
  handleEditItem?: HandleEditItem;
  disabled: boolean;
};

const CardRow: FC<CardRowProps> = ({ item, handleRemoveItem, handleEditItem, disabled }) => (
  <Box
    marginBottom={ YodaSpacing.medium }
    data-testid="user-container"
  >
    <FieldCard>
      <Box>
        <Box display="flex" fontWeight={ YodaFontWeight.light } color={ YodaColors.gray5 }>
          <Box marginRight={ YodaSpacing.xSmall }>{ `${item.property1} ${item.property2}` }</Box>
          { item.property3 && <Box>{ item.property3 }</Box> }
        </Box>
      </Box>

      {
        disabled ? null : (<Box display="flex" justifyContent="center">
          {
            handleEditItem ? (<Icon
              data-testid="edit-icon"
              name={ Icons.edit }
              style={ { fill: YodaColors.gray3, cursor: 'pointer' } }
              onClick={ () => handleEditItem(item.id) }
            />) : null
          }

          <Icon
            data-testid="close-icon"
            name={ Icons.close }
            style={ { fill: YodaColors.gray3, cursor: 'pointer' } }
            onClick={ () => handleRemoveItem(item.id) }
          />
        </Box>)
      }
    </FieldCard>
  </Box>
);

export default CardRow;
